import { ClientMsgKind, PlayerStatus } from '@infiltre/shared';
import { selectRoom } from '@/entities/room';
import { useGameStore, useSessionStore } from '@/shared/hooks/use-shallow-store';
import { useT } from '@/shared/lib/i18n';
import { HandoffComplete } from '../ui/HandoffComplete';

/**
 * Standalone "all players have seen their word" intermission. Engine gates
 * Reveal → Discuss on unanimous ack (online fairness), so on continue we
 * synthesize one `AcknowledgeWord` per alive player from this single device.
 */
export const RevealCompleteOrchestrator = () => {
  const t = useT();
  const driver = useSessionStore((s) => s.driver);
  const room = useGameStore(selectRoom);
  const resetHandoff = useGameStore((s) => s.resetHandoff);

  if (!driver || !room) return null;

  return (
    <HandoffComplete
      title={t('play.handoff.all_revealed_title')}
      description={t('play.handoff.all_revealed_description')}
      ctaLabel={t('play.handoff.continue')}
      onContinue={() => {
        for (const alive of room.players.filter((p) => p.status === PlayerStatus.Alive)) {
          driver.send({ kind: ClientMsgKind.AcknowledgeWord, actorPlayerId: alive.id });
        }
        resetHandoff();
      }}
    />
  );
};
